export enum REASON_CLOSE_DIALOG {
  BACKDROP_CLICK = 'backdropClick',
  ESCAPE_KEY_DOWN = 'escapeKeyDown',
  CLOSE_ICON_CLICK = 'closeIconClick',
}
